// This file contains all relevant JS functionality for the "home-office page" - https://www.dpj.se/content/75-hyr-kontorsmoebler 

import {modals} from './modals';

export const homeOffice = {
    init: () => {
        console.debug("home-office.js: init");
        $("body").on("click", ".home-office-send", homeOffice.submitForm);
        $(".home-office-wrapper").on("click", ".home-office-form-btn", homeOffice.renderForm);
        $(".home-office-wrapper").on("click", ".home-office-recommend-btn", homeOffice.openMailClient);
    },
    openMailClient: () => {
        window.open('mailto:?subject=Hyra Kontorssmöbler från DPJ', '_blank');
    },
    renderForm: () => {
        if ($("#home-office-modal").length) {
            $("#home-office-modal").show();
            modals.togglePageOverlay();
        }
        else {
            modals.ol.append(`
                <div class="modal-box" id="home-office-modal">
                    <i class="fas fa-times-circle close-modal"></i>
                    <div class="home-office-form">
                        <h3>Fyll i nedanstående uppgifter så kontaktar vi er.</h3>
                        <label>Namn<span class="required">*</span></label>
                        <div class="input-custom"><input type="text" id="home-office-name" name="name"></div>
                        <label>E-post<span class="required">*</span></label>
                        <div class="input-custom"><input type="text" id="home-office-email" name="email"></div>
                        <label>Telefonnummer<span class="required">*</span></label>
                        <div class="input-custom"><input type="text" id="home-office-phone" name="phone"></div>
                        <label>Organisationsnummer<span class="required">*</span></label>
                        <div class="input-custom"><input type="text" id="home-office-org-number" name="phone"></div>
                        <label>Hur många anställda är ni?<span class="required">*</span></label>
                        <div class="input-custom"><input type="text" id="home-office-employees" name="employees"></div>
                        <input type="button" class="input-button home-office-send" value="Skicka">
                    </div>
                </div>
            `);
            $("#home-office-modal").show();
            modals.togglePageOverlay();
        }
    },
    submitForm: () => {
        const name = $("#home-office-name").val();
        const email = $("#home-office-email").val();
        const phone = $("#home-office-phone").val();
        const employees = $("#home-office-employees").val();
        const orgNumber = $("#home-office-org-number").val();
        /*gtag('event', 'Hyra kontorsmöbler', {
          'event_category': 'Forms',
          'event_label': 'Submit',
        });*/
        window.dataLayer.push({
            'event': 'Hyra kontorsmöbler',
            'event_category': 'Forms',
            'event_label': 'Submit',
        });
        /*if (name == "" || email == "" || phone == "" || employees == "") {
            homeOffice.renderModal('<h3>Whoops!</h3><p>Var vänlig och fyll i alla fält innan du skickar ditt meddelande.</p>');
            return false;
        }
        else {*/
            let query = `?key=UyJENjE7gE2SfWB7&subject=Hemmakontor&Namn=${encodeURIComponent(name)}&Epost=${encodeURIComponent(email)}&Telefonnummer=${encodeURIComponent(phone)}&Anställda=${encodeURIComponent(employees)}&Organisationsnummer=${encodeURIComponent(orgNumber)}`;
            const url = `${prestashop.urls.base_url}misc/sendmail.php${query}`;
            $.ajax({
                url: url,
                success: () => {
                    $(".home-office-form").html('<h3>Tack!</h3><p>Vi har tagit emot ditt meddelande och återkommer snarast.</p>');
                },
                error: (result) => {
                    $(".home-office-form").html('<h3>Whoops!</h3><p>Något gick snett. Var vänlig försök igen!</p>');
                }
            });
        //}
    },
    /*renderModal: (msg) => {
        if ($("#home-office-modal").length) {
            $("#home-office-modal").show();
            modals.togglePageOverlay();
        }
        else {
            modals.ol.append(`
                <div class="modal-box" id="home-office-modal">
                    <i class="fas fa-times-circle close-modal"></i>
                    ${msg}
                </div>
            `);
            $("#home-office-modal").show();
            modals.togglePageOverlay();
        }
    }*/
}
